import algoliasearch from 'algoliasearch/lite'
import {simple as simpleMapping} from 'instantsearch.js/es/lib/stateMappings'

const SetDocumentTitleMixin = {
  methods: {
    setDocumentTitle () {
      const self = this
      if (self.$route.hasOwnProperty('meta') && self.$route.meta.hasOwnProperty('title')) {
        document.title = `${self.$route.meta.title}`
      }
    }
  }
}

const LoadModelMixin = {
  props: {
    uid: {
      type: String,
      required: true
    }
  },
  data: () => ({
    modelStatus: 0,
    model: null,
    modelWatcher: null
  }),
  computed: {
    modelLoaded () {
      return this.modelStatus === 2
    },
    modelLoadingMessage () {
      switch (this.modelStatus) {
        case -1:
          return 'Failed to load'
        case 0:
        case 1:
          return 'Loading...'
        case 2:
          return 'Loading complete!'
        default:
          return 'Loading...'
      }
    },
    modelUID () {
      return this.uid
    }
  },
  created () {
    // Doing this allows us to override the init method while still triggering it on create
    this.init()
  },
  methods: {
    init () {
      this.loadModel()
    },
    getModelRef(uid) {
      return this.$firebaseClient.newRef(uid)
    },
    loadModel () {
      const self = this
      this.modelStatus = 1
      const modelRef = this.getModelRef(self.modelUID)
      self.modelWatcher = modelRef.on('value', (modelSnapshot) => {
        console.log('[LOAD_MODEL_MIXIN]: Loaded model')
        // Update the model value
        self.model = {uid: modelSnapshot.key, ...modelSnapshot.val()}
        // Set status to loaded
        self.modelStatus = 2
      }, error => {
        self.modelStatus = -1
        console.error(`[LOAD_MODEL_MIXIN]: ${error}`)
      })
    }
  },
  beforeDestroy () {
    if (this.modelWatcher) {
      try {
        this.modelWatcher.off()
        console.log('[LOAD_MODEL_MIXIN]: Stopped watching model')
      } catch (e) {
        console.log('[LOAD_MODEL_MIXIN]: Failed to stop watching model')
      }
    }
  }
}

const AlgoliaSearchMixin = {
  data: () => ({
    searchClient: null,
    routing: null,
  }),
  computed: {
    algoliaClientKey () {
      return this.systemConfig.algolia.clientKey
    },
    algoliaApiKey () {
      return this.systemConfig.algolia.apiKey
    },
    indexPrefix () {
      return this.systemConfig.algolia.indexPrefix
    }
  },
  methods: {
    init () {
      // For convenience we call another method that does everything. You could just call the two required methods
      // instead
      this.setupSearchClient()
    },
    setupSearchClient () {
      this.createSearchClient()
      this.createRouting()
    },
    createSearchClient () {
      const self = this
      self.searchClient = algoliasearch(self.algoliaClientKey, self.algoliaApiKey)
    },
    createRouting () {
      const self = this
      self.routing = {
        router: {
          read () {
            return self.$router.currentRoute.query
          },
          write (routeState) {
            self.$router.push({
              query: routeState
            })
          },
          createURL (routeState) {
            return self.$router.resolve({
              query: routeState
            }).href
          },
          onUpdate (cb) {
            this._onPopState = event => {
              const routeState = event.state
              // at initial load, the state is read from the URL without
              // update. Therefore the state object is not there. In this
              // case we fallback and read the URL.
              if (!routeState) {
                cb(this.read())
              } else {
                cb(routeState)
              }
            }
            window.addEventListener('popstate', this._onPopState)
          },
          dispose () {
            window.removeEventListener('popstate', this._onPopState)
            this.write()
          }
        },
        // Can customise this; see example https://codesandbox.io/s/github/algolia/doc-code-samples/tree/master/Vue+InstantSearch/routing-vue-router
        stateMapping: simpleMapping()
      }
    }
  }
}

export {
  SetDocumentTitleMixin,
  LoadModelMixin,
  AlgoliaSearchMixin
}
